export interface NftTrait {
  trait_type: string
  value: string
}

export const findTraitByType = (traits: NftTrait[] | undefined, traitType: string): NftTrait | undefined => {
  return traits?.find((attribute) => attribute.trait_type.toLocaleLowerCase() === traitType.toLocaleLowerCase())
}
